import { Component, inject, input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { IDropdownOption, MatDropdown } from '../../../../../shared/components/mat-dropdown/mat-dropdown.component';
import { IDropdownSettings } from '../../../../../shared/components/mat-dropdown/scw-mat-dropdown.interface';
import { openDfPageOptions } from './open-df-page-configuration.interface';

@Component({
  imports: [MatDropdown],
  selector: 'open-df-page-configuration',
  styleUrl: './open-df-page-configuration.component.scss',
  templateUrl: './open-df-page-configuration.component.html',
})
export class OpenDfPageConfigurationComponent {
  private readonly translate = inject(TranslateService);

  public readonly formControl = input.required<FormControl<IDropdownOption<keyof typeof openDfPageOptions>[]>>();

  public readonly dropdownOptions = Object.keys(openDfPageOptions).map((page) => ({
    id: page,
    name: this.translate.instant(`dfPage.${page}`),
  }));

  public readonly dropdownConfiguration: IDropdownSettings = {
    enableSearchFilter: false,
    hasDelayedDefaultValue: true,
    isClientSide: true,
    repositionDropdownList: true,
    singleSelection: true,
    text: this.translate.instant('page.widgetContent.addEditDialog.openDfPageConfiguration.dropdownLabel'),
  };
}
